import { registerComponent } from '@gig/magic-common';
import NestedMarketingConsentsComponent from './nested-marketing-preferences.vue.js';

var NestedMarketingConsents = registerComponent(NestedMarketingConsentsComponent);

export { NestedMarketingConsents };
